import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

const Tabs = ({ title, tabs, stickyTab, className, ...rest }) => {
  const getRoute = localStorage.getItem("route");
  const [activeTab, setActiveTab] = useState();
  useEffect(() => {
    getRoute === "0"
      ? setActiveTab(0)
      : getRoute === "1"
      ? setActiveTab(1)
      : getRoute === "2"
      ? setActiveTab(2)
      : setActiveTab(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = (index) => {
    setActiveTab(index);
    localStorage.setItem("route", index);
  };
  return (
    <TabWrapper>
      <TabContainer className={stickyTab ? "sticky-header" : ""} {...rest}>
        <div className="header">
          {tabs?.map((tab, index) => (
            <TabButton
              key={index}
              active={activeTab === index}
              onClick={() => handleClick(index)}
            >
              {tab.title}
            </TabButton>
          ))}
        </div>
      </TabContainer>
      <TabContent>{tabs && tabs[activeTab]?.component}</TabContent>
    </TabWrapper>
  );
};

const TabWrapper = styled.div`
  width: 100%;
  .sticky-header {
    position: -webkit-sticky;
    position: sticky;
    top: -20px;
    z-index: 100;
  }
`;

const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px 8px;
  justify-content: space-between;
  /* background: #FAFAFA; */
  padding: 0 32px 16px 0;
  width: 100%;
  /* border-bottom: 1px solid black; */

  @media screen and (max-width: 500px) {
    padding: 0 32px 16px 4px;
  }
  /* margin-top: 15px; */
  /* height: 0px; */
  // overflow-x: auto;
  .header {
    display: flex;
    justify-content: start;
    /* gap: 32px; */
    width: 100%;

    @media screen and (max-width: 500px) {
      gap: 0;
    }
    /* background: #FAFAFA; */
    &__header-btn {
      padding: 0;
      border-radius: 5px;
      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
      &--icon {
        width: 20px;
      }
    }
  }
`;
const TabButton = styled.p`
  width: 100%;
  /* border-bottom: 1px solid black; */
  cursor: pointer;
  background: transparent;
  display: flex;
  justify-content: center;
  padding: 0 32px;
  font-weight: 400;
  font-size: "14px";
  border-top: 5px solid rgba(33, 56, 116, 0.2);
  text-transform: capitalize;
  ${({ active }) =>
    active &&
    css`
      border-top: 5px solid #213874;
      cursor: default;
    `};

  @media screen and (max-width: 500px) {
    font-size: "12px";
    padding: 0 8px;
  }
`;

const TabContent = styled.div`
  width: 100%;
  height: 100%;
`;

export default Tabs;
